import React from 'react';
import './footer.style.css';
import { Link } from 'react-router-dom';
import chipsImage from "../../assets/images/logos/wildChip.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faYoutube, faXTwitter, faDiscord } from '@fortawesome/free-brands-svg-icons';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <img src={chipsImage} alt="Wild Chips Logo" className="footer-logo" />
        <p>&copy; {currentYear} <Link to="https://www.georgeabdulaziz.com" target="_blank" rel="noopener noreferrer" className="footer-button">George Abdulaziz.</Link></p>
        <Link to="/terms" className="footer-button">Terms and Conditions</Link>
        <Link to="/privacy" className="footer-button">Privacy Policy</Link>
        <div className="footer-social-media">
          <a href="https://discord.gg/tYDKRqPDyc" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faDiscord} className="social-icon" />
          </a>
          <a href="https://www.facebook.com/people/Wild-Chips-Poker/61575735251567/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faFacebook} className="social-icon" />
          </a>
          {/* <a href="https://linkedin.com/in/yourusername" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faLinkedin} className="social-icon" />
          </a> */}
          <a href="https://x.com/wildchipspoker" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faXTwitter} className="social-icon" />
          </a>
          <a href="https://www.youtube.com/channel/UCePiWz0Gw_9CuIwjANFyAig" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faYoutube} className="social-icon" />
          </a>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
